import { Fragment, useRef, useState } from "react"
import type { CanvasEvent } from "./events"
import { Paths } from "./lib/paths"
import { Shape } from "./lib/processor"

type Props = {
  cellSize: number
  rows: number
  cols: number
  lineOffset: number
  shapes: Shape[]
  padding: number
}

/**
 * Component which renders Flowgram data as an SVG
 */
export function FlowgramSVGRenderer(props: Props) {
  const layers = new Map<number, Shape[]>()

  for (const shape of props.shapes) {
    if (!layers.has(shape.layerId)) {
      layers.set(shape.layerId, [shape])
    } else {
      layers.get(shape.layerId)!.push(shape)
    }
  }

  const padding = props.padding + props.shapes[0]?.style.strokeWidth / 2 || 0

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="flowgram-output"
      width={props.cols * props.cellSize + padding * 2}
      height={props.rows * props.cellSize + padding * 2}
      viewBox={`${-padding} ${-padding} ${
        props.cols * props.cellSize + padding * 2
      } ${props.rows * props.cellSize + padding * 2}`}
      style={{
        touchAction: "none",
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 15,
      }}
    >
      {[...layers.entries()].map(([layerId, shapes]) => {
        return (
          <g key={layerId}>
            {/* Draw the interactive layer */}
            {shapes.map((shape, i) => {
              return (
                <Fragment key={i}>
                  <path
                    d={Paths.stringify(shape.getPath(props.cellSize, props.lineOffset))}
                    fill={shape.style.fill || "none"}
                    stroke={shape.style.stroke || "none"}
                    strokeWidth={shape.style.strokeWidth * (props.cellSize / 20) || 0}
                  />
                </Fragment>
              )
            })}
          </g>
        )
      })}
    </svg>
  )
}
